import dayjs from "@/lib/dayjs"
import { Fragment, useState } from "react"
import Modal from "react-modal"
import { Link } from "@inertiajs/react"
import { Button } from "../Common/Button"
import { FaQuestion, FaRegClock } from "react-icons/fa"
import { ProdDescBadgeSold } from "@/Components/Common/ProdDescBadgeSold"
import { CustomProdDescCountdown } from "../Common/CustomProdDescCountdown"
import BrandLinksBanner from "@/Components/Brands/BrandLinksBanner"

export const ItemDescription = ({
    item,
    soldListing = null,
    brandFacets = null,
}) => {
    const endingTime = item.ending_time
        ? dayjs.utc(item.ending_time).tz("America/New_York")
        : null
    const hasEnded = endingTime?.isBefore(dayjs()) ?? false
    const formattedEndingTime =
        endingTime?.format("MMMM D, YYYY [at] h:mm A") ?? null
    const [showTableModal, setShowTableModal] = useState(false)
    const [showTableModalMobile, setShowTableModalMobile] = useState(false)

    const keyFeatures = Object.entries(item.gun.key_features).map(
        ([key, value]) => ({ key, value })
    )
    const specifications = Object.entries(item.gun.specifications).map(
        ([key, value]) => ({ key, value })
    )

    const toggleTableModal = () => {
        setShowTableModal(!showTableModal)
    }

    const toggleTableModalMobile = () => {
        setShowTableModalMobile(!showTableModalMobile)
    }

    return (
        <div className="flex-auto">
            {item.status === "ACTIVE" ? (
                <div className="hidden lg:flex mt-[60px] flex mb-[30px]">
                    <CustomProdDescCountdown
                        className="rounded-[10px] py-[8.5px] px-[20px] mb-[0px] ms-[0px] ms-0 flex-grow"
                        targetTime={endingTime}
                        currentBid={item.current_bid}
                        style={{ marginLeft: "0 !important" }}
                        gunbrokerId={item.gun.gunbroker_item_id}
                    />

                    <Button
                        disabled={hasEnded}
                        type="submit"
                        className="ms-2 w-[200=px] leading-[19.36px]"
                        variant="green"
                        style={{
                            marginLeft: "40px",
                            ...(hasEnded
                                ? { cursor: "not-allowed", opacity: "0.6" }
                                : {}),
                        }}
                        onClick={() =>
                            window.open(
                                `https://www.gunbroker.com/item/${item.gun?.gunbroker_item_id}`,
                                "_blank"
                            )
                        }
                    >
                        Place Bid
                    </Button>
                </div>
            ) : (
                <Fragment>
                    <div className="hidden mt-10 lg:block">
                        <ProdDescBadgeSold className="flex w-[100%]">
                            <span className="ml-5">Sold On:</span>
                            <span className="mr-5">{formattedEndingTime}</span>
                        </ProdDescBadgeSold>
                    </div>
                    <div className="flex w-[100%] mt-2 lg:hidden">
                        <ProdDescBadgeSold className="flex w-[100%]">
                            <span className="ml-5 text-sm lg:text-sm">
                                Sold On:
                            </span>
                            <span className="mr-5 text-sm lg:text-sm">
                                {formattedEndingTime}
                            </span>
                        </ProdDescBadgeSold>
                    </div>

                    {soldListing && (
                        <div className="w-full mt-5">
                            <Link
                                href={soldListing.href}
                                className="flex items-center w-full gap-4 px-5 py-4 transition-colors bg-gray-100 border border-gray-300 rounded-xl group hover:bg-gray-200 hover:border-gray-400"
                            >
                                <span className="flex items-center justify-center flex-none text-gray-600 bg-gray-200 rounded-full w-11 h-11">
                                    <FaRegClock className="w-5 h-5" />
                                </span>
                                <p className="flex-auto text-[15px] lg:text-base leading-relaxed text-black">
                                    This auction has ended. Browse more{" "}
                                    <span className="font-bold">
                                        {soldListing.label}
                                    </span>
                                    {soldListing.pluralSuffix ?? "s"} for sale on
                                    FirearmLand.
                                </p>
                                <span
                                    aria-hidden="true"
                                    className="self-center flex-none text-xl text-gray-500 transition-transform group-hover:translate-x-1"
                                >
                                    &rarr;
                                </span>
                            </Link>
                        </div>
                    )}
                </Fragment>
            )}

            {item.status === "ACTIVE" && (
                <div className="flex items-center w-full mb-5 lg:hidden">
                    <CustomProdDescCountdown
                        className="rounded-[10px] py-[8.5px] px-[10px] flex-grow text-sm h-[53px]"
                        targetTime={endingTime}
                        currentBid={item.current_bid}
                        style={{ marginRight: "10px", maxWidth: "calc(70% )" }}
                        gunbrokerId={item.gun?.gunbroker_item_id}
                    />
                    <Button
                        disabled={hasEnded}
                        type="submit"
                        className="ms-2 w-[3/4] leading-[19.36px]"
                        variant="green"
                        style={{
                            ...(hasEnded
                                ? { cursor: "not-allowed", opacity: "0.6" }
                                : {}),
                        }}
                        onClick={() =>
                            window.open(
                                `https://www.gunbroker.com/item/${item.gun?.gunbroker_item_id}`,
                                "_blank"
                            )
                        }
                    >
                        <span className="text-[15px]">Place Bid</span>
                    </Button>
                </div>
            )}

            <div className="flex justify-between mt-3">
                <div className="relative inline-flex items-center w-full text-lg">
                    <span
                        className="hidden lg:block me-2 text-[#000] rounded-full p-1 bg-[#d9d9d9] w-[21px] h-[21px] cursor-pointer"
                        onClick={toggleTableModal}
                    >
                        <FaQuestion className="text-[12px]" />
                    </span>
                    <span
                        className="relative hidden lg:block group"
                        onClick={toggleTableModal}
                    >
                        <span className="cursor-pointer hover:underline">
                            How Buying Works
                        </span>
                    </span>
                    <span
                        className="block lg:hidden me-2 text-[#000] rounded-full p-1 bg-[#d9d9d9] w-[21px] h-[21px] cursor-pointer"
                        onClick={toggleTableModalMobile}
                    >
                        <FaQuestion className="text-[12px]" />
                    </span>
                    <span
                        className="flex justify-between block w-full lg:hidden group"
                        onClick={toggleTableModalMobile}
                    >
                        <span className="cursor-pointer hover:underline text-[0.7rem] lg:text-sm font-bold">
                            How Buying Works
                        </span>

                        <span className="ml-[30px] text-[0.7rem] lg:text-sm">
                            {item.status === "ACTIVE" ? "Ending " : "Ended on "}
                            {formattedEndingTime}
                        </span>
                    </span>
                </div>

                <p className="hidden lg:block leading-[19.36px]">
                    {item.status === "ACTIVE" ? "Ending " : "Ended on "}{" "}
                    {formattedEndingTime}
                </p>
            </div>

            {item.gun?.appraiser_comment && (
                <div className="mt-8">
                    <div className="relative p-4 rounded-lg bg-neutral-100">
                        <div className="flex items-center mb-4">
                            <img
                                src={item.gun?.appraiser_image_url}
                                alt="Appraiser's Image"
                                className="w-12 h-12 rounded-full"
                            />
                            <h3 className="text-lg font-semibold ms-3">
                                Appraiser's Take
                            </h3>
                        </div>
                        <p className="leading-[19.36px]">
                            {item.gun?.appraiser_comment}
                        </p>
                    </div>
                </div>
            )}

            <div className="mt-8">
                <div className="rounded-l-lg">
                    <div className="">
                        <h3 className="text-[32px] lg:text-[32px] font-medium mb-4">
                            Key Features
                        </h3>
                        <ul className="pl-8 mb-4 list-disc">
                            {keyFeatures.map((feature, index) => (
                                <li key={index} className="mb-2">
                                    <span className="font-semibold">
                                        {feature.key}:{" "}
                                    </span>
                                    {feature.value}
                                </li>
                            ))}
                        </ul>

                        <BrandLinksBanner brandFacets={brandFacets} />

                        <h3 className="text-[32px] font-medium mb-4 mt-[48px]">
                            Product Description
                        </h3>
                        <ul>
                            <article
                                className="prose"
                                dangerouslySetInnerHTML={{
                                    __html: item.gun?.product_description,
                                }}
                            />
                        </ul>

                        <h3 className="text-[32px] font-medium mb-8 mt-[48px]">
                            Specifications
                        </h3>
                        <table className="table-auto w-[100%]">
                            <tbody>
                                {specifications.map((specification, index) => (
                                    <tr key={index}>
                                        <td className="border border-light-gray bg-tbl-gray font-semibold py-[13px] px-9 text-left">
                                            {specification.key}
                                        </td>
                                        <td className="border border-light-gray py-[13px] px-4">
                                            {specification.value}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Modal
                closeTimeoutMS={300}
                isOpen={showTableModal}
                onRequestClose={toggleTableModal}
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.9)",
                    },
                    content: {
                        maxWidth: "100%",
                        margin: "auto",
                        overflow: "hidden",
                        backgroundColor: "#fff",
                        border: "none",
                        borderRadius: "8px",
                        height: "560px",
                        width: "1040px",
                    },
                }}
            >
                <button
                    className="absolute p-1 text-sm text-gray-600 rounded-md top-1 right-2 hover:bg-neutral-200 focus:outline-none"
                    onClick={toggleTableModal}
                >
                    X
                </button>
                <table
                    className="border border-#B5B5B5"
                    style={{
                        width: "95%",
                        margin: "auto",
                        marginTop: "20px",
                        fontSize: "14px",
                    }}
                >
                    <tbody>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2 w-[350px] align-top">
                                Item #
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                {item.gun?.gunbroker_item_id}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2 w-[350px] align-top">
                                Location
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                FL 32216 us
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2 w-[350px] align-top">
                                Shipping
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                103 Shipping rates could vary based on the
                                number of items.0605803 Showing rate for 1 item
                                Overnight $100.00 2nd Day $75.00 3rd Day$29.00
                                Alaska, Hawaii & US Terr.$75.00 No international
                                shipments
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2 w-[350px] align-top">
                                Payment Methods
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                Personal Check, Visa/MasterCard , American
                                Express, Discover, USPS Money Order, Money
                                Order, Certified CheckCheckoutImmediate
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2 w-[350px] align-top">
                                Checkout
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                Immediate Checkout - Credit Card + 3% Credit
                                Card Fee
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2 w-[350px] align-top">
                                Cash Discount
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                The above prices on this item reflect a 3%
                                cash/check discount. This discount is not valid
                                for credit card purchases.
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2 w-[350px] align-top">
                                Applicable Tax and Fees
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                Sales tax collected based on ship to address
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2 w-[350px] align-top">
                                Inspection/ Return Policy
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                AS IS - No refund or exchange
                            </td>
                        </tr>
                    </tbody>
                </table>

                <p
                    className="mt-10 font-light"
                    style={{
                        width: "95%",
                        margin: "auto",
                        marginTop: "20px",
                        fontSize: "14px",
                    }}
                >
                    The seller of this item assumes all responsibility for this
                    listing. You must contact the seller to resolve any
                    questions or concerns before placing a bid. Payment must be
                    made using U.S. dollars ($) unless otherwise stated in the
                    listing. Firearms may only be shipped to a licensed dealer
                    (FFL Holder). Some listed items may not be legal in every
                    state. <u>Complete your purchase within the law.</u>
                </p>
            </Modal>

            <Modal
                closeTimeoutMS={300}
                isOpen={showTableModalMobile}
                onRequestClose={toggleTableModalMobile}
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                    },
                    content: {
                        margin: "auto",
                        overflow: "auto",
                        backgroundColor: "#fff",
                        border: "none",
                        borderRadius: "8px",
                        overflowX: "hidden",
                    },
                }}
            >
                <button
                    className="absolute p-1 text-sm text-gray-600 rounded-md top-1 right-2 hover:bg-neutral-200 focus:outline-none"
                    onClick={toggleTableModalMobile}
                >
                    X
                </button>
                <table
                    className="relative border border-#B5B5B5 mt-5"
                    style={{ width: "95%", margin: "auto" }}
                >
                    <tbody>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2 align-top">
                                Item #
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                {item.gun?.gunbroker_item_id}
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2  align-top">
                                Location
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                FL 32216 us
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2  align-top">
                                Shipping
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                103 Shipping rates could vary based on the
                                number of items.0605803 Showing rate for 1 item
                                Overnight $100.00 2nd Day $75.00 3rd Day$29.00
                                Alaska, Hawaii & US Terr.$75.00 No international
                                shipments
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2  align-top">
                                Payment Methods
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                Personal Check, Visa/MasterCard , American
                                Express, Discover, USPS Money Order, Money
                                Order, Certified CheckCheckoutImmediate
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2  align-top">
                                Checkout
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                Immediate Checkout - Credit Card + 3% Credit
                                Card Fee
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2  align-top">
                                Cash Discount
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                The above prices on this item reflect a 3%
                                cash/check discount. This discount is not valid
                                for credit card purchases.
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2  align-top">
                                Applicable Tax and Fees
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                Sales tax collected based on ship to address
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-light-gray bg-tbl-gray font-semibold py-[10px] px-2  align-top">
                                Inspection/ Return Policy
                            </td>
                            <td className="border border-light-gray py-[10px] px-2">
                                AS IS - No refund or exchange
                            </td>
                        </tr>
                    </tbody>
                </table>

                <p
                    className="mt-10 font-light"
                    style={{
                        width: "95%",
                        margin: "auto",
                        marginTop: "20px",
                        fontSize: "14px",
                    }}
                >
                    The seller of this item assumes all responsibility for this
                    listing. You must contact the seller to resolve any
                    questions or concerns before placing a bid. Payment must be
                    made using U.S. dollars ($) unless otherwise stated in the
                    listing. Firearms may only be shipped to a licensed dealer
                    (FFL Holder). Some listed items may not be legal in every
                    state. <u>Complete your purchase within the law.</u>
                </p>
            </Modal>
        </div>
    )
}
